import { render, staticRenderFns } from "./AddorEdit.vue?vue&type=template&id=a7128fe4&scoped=true&"
import script from "./AddorEdit.vue?vue&type=script&lang=js&"
export * from "./AddorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7128fe4",
  null
  
)

export default component.exports